
























import Vue from 'vue'
import { ContactPickerWithButtonInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ContactPickerWithButtonEl',
  data: function () {
    return {
      number: ''
    }
  },
  props: {
    templateItemData: {
      type: Object as () => ContactPickerWithButtonInterface,
      required: true
    }
  }
})
